import { Input, QueryList, ViewChild, Component, ElementRef, HostListener, Inject, OnInit, } from '@angular/core';
import { CoursesService } from 'src/providers/courses.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { MatSnackBar } from '@angular/material/snack-bar';
import { ThanksDialogueComponent } from '../thanks-dialogue/thanks-dialogue.component';
import { DashboardService } from 'src/providers/dashboard.service';
import { LOCAL_STORAGE } from '@ng-toolkit/universal';
import { error } from 'console';
import { Meta, Title } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { LoginService } from 'src/providers/login.service';
import { JSONIDService } from 'src/providers/schema';

@Component({
  selector: 'app-clat-hardcopy',
  templateUrl: './clat-hardcopy.component.html',
  styleUrls: ['./clat-hardcopy.component.scss']
})
export class ClatHardcopyComponent {
  coursesArray: any[] = [];

  toppersImg: any[] = [
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.12+(1).jpeg',},
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.12.jpeg', },
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.13+(1).jpeg', },
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.13+(2).jpeg', },
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.13.jpeg', }, 
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.14+(1).jpeg', }, 
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.14+(2).jpeg', }, 
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.14.jpeg', },
    { img: 'https://media.iquanta.in/ui_images/feed-img/WhatsApp+Image+2024-03-06+at+18.31.15.jpeg', } 
    ]

  legalreasoning:any[]=[
    {img:'https://media.iquanta.in/ui_images/legal-1.jpg' , text:'250 + questions Flly Passage Based'},
    {img:'https://media.iquanta.in/ui_images/legal-2.jpg' , text:'250+ questions + 50+ case studies'},
    {img:'https://media.iquanta.in/ui_images/legal-3.jpg' , text:'250 +  Question'},
    {img:'https://media.iquanta.in/ui_images/legal-4.jpg' , text:'250 +  Question'},
    {img:'https://media.iquanta.in/ui_images/legal-5.jpg' , text:'250 +  Question'},
  ]


  english: any[] = [
    {img:'https://media.iquanta.in/ui_images/clat-eng-1.jpg' , text:'500+ Practice questions'},
    {img:'https://media.iquanta.in/ui_images/clat-eng-2.jpg' , text:'All importantt topic questions'},

  ]


  Quantittative: any[] = [
    {img:'https://media.iquanta.in/ui_images/clat-qt-1.jpg' , text:'All important  topics explained with illustrationns'},
  ]

  Logical:any[] =[
    {img:'https://media.iquanta.in/ui_images/clat-logical-1.jpg' , text:'Passage based  (300+ practice based questions)'},
    {img:'https://media.iquanta.in/ui_images/clat-logical-2.jpg' , text:'Analytical Reasoning (non-clat exam)'},
  ]


  joinwhatsapp(){
    window.open('https://chat.whatsapp.com/Cp72hMNpsy5AgRhjNTsNqo', '_blank')
  }
  demovideos(){
    window.open('https://www.youtube.com/playlist?list=PLrYkV6r41J8XBBl9zWT5QJWNU7wiE8iFB', '_blank')
  }


  constructor( 
    public coursesService: CoursesService,
    public dialog: MatDialog, 
    private titleService: Title, 
    private metaService: Meta, 
    @Inject(DOCUMENT) private dom: any, 
    public ClatBooksService: JSONIDService, 
    public matSnackbar: MatSnackBar,  @Inject(LOCAL_STORAGE) public sessionStorage: any, ) {

  }

  public scrolling = false;
  private timeout: any;
  @HostListener('window:scroll', ['$event'])
  onScroll(event:any) {
    this.scrolling = true;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.scrolling = false;
    }, 200);
  }
  

  checkValidity(){
    if(this.sessionStorage.getItem('usertoken')){
      this.coursesService.getUserAddress(this.sessionStorage.getItem('usertoken')).subscribe(res=>{
        if(res.success){
          this.openThankModal({success:true, data: res.data[0]})
        }else{
          this.clatEnquiryForm()
        }
      })
    }else{
      this.matSnackbar.open('Please login to proceed','OK',{
        verticalPosition:'top',
        duration:3000,
        panelClass:'snack-error'
      })
    }
   
  }

  // getCourses() {
  //   this.coursesArray = []
  //   this.coursesService.getPagewiseCourses('IPMAT', 'landingpage', '2023').subscribe(res=>{
  //     if (res.success) {
  //       if(res.data.length > 0){
  //       this.coursesArray = res.data[0].course.filter((x:any)=> !x.is_rq);
  //       this.coursesArray.sort((a, b) => a.course_name < b.course_name ? -1 : 1)
  //       }
  //     }
  //   })
  // }

  clatEnquiryForm() {
    const dialog = this.dialog.open(FormDialog, {
      width: '450px',
      panelClass: 'enquiry-modal',
      data: 'CAT 2024'
    })

    dialog.afterClosed().subscribe((result: any) => {
      if (result.success) {
        this.openThankModal(result)
      } else if(!result.success){
        this.openThankModal(result)
      }
    })
  }

openThankModal(msg:any){
    const dialog = this.dialog.open(thankyoudialog, {
        width: '450px',
        panelClass: 'enquiry-modal',
        data: msg
      })
  
      dialog.afterClosed().subscribe((result: any) => {
        if (result == 'buy') {
       var elemnt: any = document.getElementById('courses')
       elemnt.scrollIntoView({ behavior: "smooth" })
        } else {
        
        }
      })
}

  json1:any;
  json2:any;
  token: any;
  ngOnInit(): void {
    this.getPageCourses()
    this.json1 = this.ClatBooksService.ClatBooksBreadcrumbList;
    this.json2 = this.ClatBooksService.ClatBooksProduct;   
     // Meta Data
   this.titleService.setTitle("Best Books for CLAT Preparation 2026 by iQuanta");
   this.metaService.updateTag( 
   { name: 'description', content: "Discover the Best Books for CLAT Preparation 2026 to boost your CLAT score. Our CLAT books feature detailed guides, practice sets, and expert strategies tailored to help you excel in every section of the CLAT exam."}); 
   this.metaService.updateTag( 
   { name: 'keywords', content: 'clat books,best book for clat preparation,best book for clat,clat preparation books,best institutes for clat preparation,best clat books,clat book,Best books for ClAT' });
// Canonical Link
   const head = this.dom.getElementsByTagName('head')[0];
   var element: HTMLLinkElement = this.dom.createElement('link') as HTMLLinkElement
   head.appendChild(element);
   element.setAttribute('rel', 'canonical')
   element.setAttribute('href', 'https://www.iquanta.in/best-clat-books')
// Facebook
   this.metaService.updateTag(
     { property: 'og:type', content: "website" })
   this.metaService.updateTag(
     { property: 'article:publisher', content: "https://facebook.com/iquanta.in" })
   this.metaService.updateTag(
     { property: 'og:title', content: "Best Books for CLAT Preparation 2026 by iQuanta" })
   this.metaService.updateTag(
     { property: 'og:url', content: 'https://www.iquanta.in/best-clat-books' })
   this.metaService.updateTag(
     { property: 'og:description', content: "Discover the Best Books for CLAT Preparation 2026 to boost your CLAT score. Our CLAT books feature detailed guides, practice sets, and expert strategies tailored to help you excel in every section of the CLAT exam." });
   this.metaService.updateTag(
     { property: 'og:image:height', content: '720' })
   this.metaService.updateTag(
     { property: 'og:image:width', content: '1280' })
   this.metaService.updateTag(
     { property: 'og:image:type', content: 'image/webp' })
   this.metaService.updateTag(
     { property: 'og:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/12/best-cLat-books.webp' })
// Article Publish Time
   this.metaService.updateTag(
     { property: 'article:published_time', content: '2024-12-04T11:11:42+00:00' })
   this.metaService.updateTag(
     { property: 'article:modified_time', content: '2024-12-16T12:11:42+00:00' })
// Twitter
   this.metaService.updateTag(
     { property: 'twitter:label2', content: "Est. reading time" })
   this.metaService.updateTag(
     { property: 'twitter:data2', content: "9 Minutes" })
   this.metaService.updateTag(
     { property: 'twitter:title', content: "Best Books for CLAT Preparation 2026 by iQuanta" })
   this.metaService.updateTag(
     { property: 'twitter:url', content: 'https://www.iquanta.in/best-clat-books' })
   this.metaService.updateTag(
     { property: 'twitter:description', content: "Discover the Best Books for CLAT Preparation 2026 to boost your CLAT score. Our CLAT books feature detailed guides, practice sets, and expert strategies tailored to help you excel in every section of the CLAT exam." });
   this.metaService.updateTag(
     { property: 'twitter:image', content: 'https://www.iquanta.in/blog/wp-content/uploads/2024/12/best-cLat-books.webp' })
   this.metaService.updateTag(
     { property: 'twitter:image:height', content: '720' })
   this.metaService.updateTag(
     { property: 'twitter:image:type', content: 'image/webp' })
   this.metaService.updateTag(
     { property: 'twitter:image:width', content: '1280' })
  }

  getPageCourses() {
    this.coursesArray = [];
    this.coursesService.getPagewiseCourses('CLAT', 'landingpage', '2024').subscribe(res => {
      if (res.success) {
        this.coursesArray = res.data[0].course.filter((x: any) => !x.is_rq);

      }
    })
  }


  gotocourse() {
    var elemnt: any = document.getElementById('courses')
    elemnt.scrollIntoView({ behavior: "smooth" })
  }
}




@Component({
  selector: 'app-form',
  templateUrl: './form.html',
  styleUrls: ['./clat-hardcopy.component.scss']
})
export class FormDialog {
  devlieryDateForm!: FormGroup;
  submittedBtn: boolean = false;
  url: any;
  page_loaction: any
  token:any

  constructor(public dialogRef: MatDialogRef<FormDialog>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any, public loginService: LoginService) {
   
  this.getCities()
  }

  cityList:any[] = [];
  getCities() {
    this.loginService.getIndianCities().subscribe(res => {
      if (res) {
        this.cityList = res;
      }
    })
  }

  filter(event: any) {
    if (this.devlieryDateForm.value.city) {
      const filterValue = this.devlieryDateForm.value.city.toLowerCase();
      this.cityList = this.cityList.filter(option => option.toLowerCase().includes(filterValue));
    } else {
      this.getCities()
    }

  }

  ngOnInit() {

    this.token = this.sessionStorage.getItem('usertoken');

    this.devlieryDateForm = this.formBuilder.group({

      city: ['', Validators.required],
      state: ['', Validators.required],
      address1: ['', Validators.required],
      address2: ['', Validators.required],
      pincode: ['', Validators.required],

    })
  }

  save() {
    if (this.devlieryDateForm.valid) {
      if(this.token){
        this.submittedBtn = true;
        this.courseService.hardCopyForm(this.token, this.devlieryDateForm.value).subscribe((res:any) => {
          // this.dialogRef.close(res)
          if (res.success) {
            // this.addNPF()
            console.log(res)
            // localStorage.setItem('dialogCloseTime', new Date().getTime().toString());
            this.dialogRef.close(res)
          } else if(!res.success) {
           
          }
        }, err =>{
            this.dialogRef.close(err.error)
        }  )
      } else {
        this.matSnackBar.open('Please Login', 'OK', {
          verticalPosition: 'top',
          duration: 3000,
          panelClass: 'snack-error'
        })
      }
    } else {
      this.matSnackBar.open('Please enter valid Details', 'OK', {
        verticalPosition: 'top',
        duration: 3000,
        panelClass: 'snack-error'
      })
    }

  }

  addNPF() {
    let reqObj = {
      "secret_key": "bd0f12c20c7949caa22d5635f44c1732",
      "college_id": "5802",
      "name": this.devlieryDateForm.value.name,
      "field_last_name": '',
      "country_dial_code": "+91",
      "mobile": this.devlieryDateForm.value.phone,
      "email": this.devlieryDateForm.value.email,
      "field_gender": '',
      "field_exam_category": this.devlieryDateForm.value.course,
      "field_exam": "",
      "field_course_year": '',
      "source": "Website",
      "medium": this.data ? this.data : 'Call Back Form'

    }

    this.dashboardService.addLeadSquared(reqObj).subscribe(res => {

    })

  }

  close() {
    this.dialogRef.close()
  }

}

@Component({
    selector: 'app-thank-modal',
    templateUrl: './thank-modal.html',
    styleUrls: ['./clat-hardcopy.component.scss']
  })
  export class thankyoudialog {

    constructor(public dialogRef: MatDialogRef<FormDialog>, public formBuilder: FormBuilder, @Inject(LOCAL_STORAGE) public sessionStorage: any,
    public matSnackBar: MatSnackBar, public courseService: CoursesService, public dashboardService: DashboardService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    
  
  }

  close() {
    this.dialogRef.close()
  }

  buynow(){
    this.dialogRef.close('buy')
  }

  ngOnInit() {
    console.log(this.data)
  }

    onNoClick(res:any): void {
        this.dialogRef.close(res);
      }

  }